import React from 'react';
import {observer} from 'mobx-react';
import {TechseeBaseComponent} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-component';
import {GenericModal} from '@techsee/techsee-ui-common/lib/modals/generic';
import Translate from '../../components/translate/Translate';
import {AcceptTermsModalController} from './AcceptTermsModal.controller';
import './AcceptTermsModal.scss';

interface AcceptTermsModalProps {
    ctrl: AcceptTermsModalController;
}

const Header = () => {
    return null;
};

const Content = ({ctrl}: {ctrl: AcceptTermsModalController}) => {
    return (
        <div className='accept-terms-modal-body' dir={ctrl.dir}>
            <p className='terms-message'>
                <Translate text='TERMS.ACCEPT_TERMS.ABOVE_TERMS' />
            </p>
            <iframe src={ctrl.state.termsPath} sandbox='allow-popups' />
            {!ctrl.state.readOnly && (
                <p className='please-accept'>
                    <Translate text='TERMS.ACCEPT_TERMS.BELOW_TERMS' />
                </p>
            )}
        </div>
    );
};

const Footer = ({ctrl}: {ctrl: AcceptTermsModalController}) => {
    return (
        <div className='accept-terms-modal-footer' dir={ctrl.dir}>
            <button className='btn btn-primary' type='button' onClick={() => ctrl.close()}>
                {ctrl.state.readOnly ? (
                    <Translate text='TERMS.ACCEPT_TERMS.CLOSE' />
                ) : (
                    <Translate text='TERMS.ACCEPT_TERMS.ACCEPT' />
                )}
            </button>
        </div>
    );
};

@observer
export class AcceptTermsModal extends TechseeBaseComponent<AcceptTermsModalProps> {
    renderInternal(): JSX.Element {
        const {ctrl} = this.props;

        return (
            <GenericModal
                className='modal-dialog accept-terms-modal custom-position'
                header={() => <Header />}
                content={() => <Content ctrl={ctrl} />}
                toolbar={() => <Footer ctrl={ctrl} />}
                show={ctrl.state.isVisible}
                onHideHandler={() => ctrl.dismiss()}
                closeOnEscape={false}
                isCloseVisible={false}
            />
        );
    }
}
